<template>
  <div>
    <div>
      <label>
        <!--<gmap-autocomplete
          @place_changed="setPlace">
        </gmap-autocomplete>-->
        <button @click="addMarkerWithArray">All Status</button>
        <button @click="addMarkerWithArrayDistribue">Distribué</button>
        <button @click="addMarkerWithArrayPick">Pick</button>
        <button @click="addMarkerWithArrayEntraitement">En Attente</button>
        <button @click="hideAllMarkers">Remove Markers</button>
      </label>
      <br/>

    </div>
    <br>
    <h1>Origine</h1>
    <gmap-map
      :center="center"
      :zoom="12"
      style="width:100%;  height: 400px;"
    >
      <GmapCluster :position="center" :clickable="true" :animation="2">
        <gmap-marker
          v-for="(item, index) in markers"
          :key="index"
          :position="item.position"
          :clickable="true"
          :icon="markerIcon"
          @click="item.open = !item.open">
        </gmap-marker>

        <gmap-info-window
          :options="{maxWidth: 300}"
          :position="infoWindow.position"
          :opened="infoWindow.open"
          @closeclick="property.open = false">
          <div v-html="infoWindow.template"></div>
        </gmap-info-window>
      </GmapCluster>
    </gmap-map>
    <h1>Destination</h1>
    <gmap-map
      :center="center"
      :zoom="12"
      style="width:100%;  height: 400px;"
    >
      <GmapCluster :position="center" :clickable="true" :animation="2">
        <gmap-marker
          v-for="(item, index) in markers2"
          :key="index"
          :position="item.position2"
          :clickable="true"
          :icon="markerIcon"
          @click="toggleInfoWindow(item.position2,index)">
        </gmap-marker>

        <gmap-info-window
          :options="{maxWidth: 300}"
          :position="infoWindow2.position2"
          :opened="infoWindow2.open"
          @closeclick="property.open = false">
          <div v-html="infoWindow2.template"></div>
        </gmap-info-window>
      </GmapCluster>
    </gmap-map>
  </div>
</template>

<script>
  import {db} from '../../../../firebase.js'

  export default {
    name: 'GoogleMap',
    data () {
      return {
        // default to Montreal to keep it simple
        // change this to whatever makes sense
        center: { lat: 45.508, lng: -73.587 },
        infoWindow: {
          position: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
        infoWindow2: {
          position2: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
        markers: [],
        places: [],
        markers2: [],
        places2: [],
        defaultCountryCode: null,
        defaultMode: 'address',
        googleMapsApiKey: 'AIzaSyDKYyoAdkuKtDyajGZ8K4NBA1KgwJMljj4',
        googleMapsUrl: 'https://maps.googleapis.com/maps/api/geocode/json',
        currentPlace: null,
        currentPlace2: null
      }
    },
    created () {
      this.$bindAsArray('processing', db.ref('database/transporter/' + this.$store.state.authorization.company + '/deliveries/'))
    },
    mounted () {
      this.geolocate()
      // this.addMarkerWithArray()
      // this.$bindAsArray('processing', db.ref('database/transporter/' + this.$store.state.authorization.company + '/deliveries/').limitToLast(500))
    },
    methods: {
      // receives a place object via the autocomplete component
      setPlace (place) {
        this.currentPlace = place
      },
      setPlace2 (place) {
        this.currentPlace2 = place
      },
      toggleInfoWindow: function (marker, idx) {
        this.infoWindow.position = marker.position
        this.infoWindow.content = 'hey'

        // check if its the same marker that was selected if yes toggle
        if (this.currentMidx === idx) this.infoWinOpen = !this.infoWinOpen

        // if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      openInfoWindowTemplate (item) {
        // this.setInfoWindowTemplate(item)
        this.infoWindow.position = this.getCoordinates(item)
        this.infoWindow.open = true
      },
      openWindow (item) {
        this.markers.map(marker => {
          this.$set(item, 'open', true)
          return item
        })
      },
      addMarker () {
        if (this.currentPlace) {
          const marker = {
            lat: this.currentPlace.geometry.location.lat(),
            lng: this.currentPlace.geometry.location.lng()
          }
          this.markers.push({ position: marker })
          this.places.push(this.currentPlace)
          this.center = marker
          this.currentPlace = null
        }
      },
      hideAllMarkers () {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i]['visibility'] = false
        }
      },
      addMarkerWithArray () {
        console.log('hi')
        this.processing.forEach((o) => {
          console.log('hi2')
          if (o.latitude !== null && o.longitude !== null && o.status !== 'Terminée') {
            console.log('hi3')
            const marker = {
              lat: o.latitude,
              lng: o.longitude
            }
            this.markers.push({position: marker})
            this.places.push(this.currentPlace)
            this.center = marker
            this.currentPlace = null
          }
        })
      },
      addMarkerWithArrayPick () {
        console.log('hi')
        this.processing.forEach((o) => {
          console.log('hi2')
          if (o.latitude !== null && o.longitude !== null && o.status === 'Pick') {
            console.log('hi3')
            const marker = {
              lat: o.latitude,
              lng: o.longitude
            }
            this.markers.push({position: marker})
            this.places.push(this.currentPlace)
            this.center = marker
            this.currentPlace = null
          }
        })
      },
      addMarkerWithArrayDistribue () {
        console.log('hi')
        this.processing.forEach((o) => {
          console.log('hi2')
          if (o.transmitterLng !== null && o.transmitterLat !== null && o.status === 'Dispatch') {
            console.log('hi3')
            const marker = {
              lat: o.transmitterLat,
              lng: o.transmitterLng
            }
            this.markers.push({position: marker})
            this.places.push(this.currentPlace)
            this.center = marker
            this.currentPlace = null
          }
          if (o.receiverLng !== null && o.receiverLat !== null && o.status === 'Dispatch') {
            console.log('hi3')
            const marker = {
              lat: o.receiverLat,
              lng: o.receiverLng
            }
            this.markers2.push({position2: marker})
            this.places2.push(this.currentPlace2)
            this.center = marker
            this.currentPlace2 = null
          }
        })
      },
      addMarkerWithArrayEntraitement () {
        console.log('hi')
        this.processing.forEach((o) => {
          console.log('hi2')
          if (o.transmitterLng !== null && o.transmitterLat !== null && o.status === 'Processing') {
            console.log('hi3')
            const marker = {
              lat: o.transmitterLat,
              lng: o.transmitterLng
            }
            this.markers.push({position: marker})
            this.places.push(this.currentPlace)
            this.center = marker
            this.currentPlace = null
          }
          if (o.receiverLng !== null && o.receiverLat !== null && o.status === 'Processing') {
            console.log('hi3')
            const marker = {
              lat: o.receiverLat,
              lng: o.receiverLng
            }
            this.markers2.push({position2: marker})
            this.places2.push(this.currentPlace2)
            this.center = marker
            this.currentPlace2 = null
          }
        })
      },
      geolocate: function () {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        })
      }
    }
  }
</script>
